export const PRE_GREETING_ROUTING = 'pre-greeting-routing';
//# sourceMappingURL=pre-greeting-routing.js.map